import { createWebHistory, createRouter } from 'vue-router';
import { authGuard } from './auth-gaurd';

const routes = [
    { path: '/:catchAll(.*)', redirect: { name: 'Login' } },
    {
        path: '/auth/login',
        name: 'Login',
        component: () => import('@/components/login.vue')
    }, {
        path: '/auth/forget-password',
        name: 'ForgetPassword',
        component: () => import('@/components/forgetPassword.vue')
    }, {
        path: '/admin',
        name: 'Application',
        beforeEnter: authGuard,
        component: () => import('@/layout/PageLayout.vue'),
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('@/components/DashboardView.vue')
            }, {
                path: '/roles',
                name: 'RolePage',
                component: () => import('@/components/Role.vue')
            }, {
                path: '/privilages',
                name: 'PrivilagePage',
                component: () => import('@/components/Privilage.vue')
            }, {
                path: '/state-city',
                name: 'StateCityPage',
                component: () => import('@/components/StateCity.vue')
            }, {
                path: '/users',
                name: 'User',
                component: () => import('@/components/Users.vue')
            }, {
                path: '/endpoint-integration',
                name: 'ApiIntegration',
                component: () => import('@/components/Api.vue')
            }, {
                path: '/webhooks',
                name: 'WebHook',
                component: () => import('@/components/WebHooks.vue')
            }, {
                path: '/payment-integration',
                name: 'Payment',
                component: () => import('@/components/PaymentIntegration.vue')
            }, {
                path: '/wallet',
                name: 'Wallet',
                component: () => import('@/components/Wallets.vue')
            }, {
                path: '/aggregators',
                name: 'ServiceAggregator',
                component: () => import('@/components/ServiceAggregators.vue')
            }, {
                path: '/service-providers',
                name: 'ServiceProvider',
                component: () => import('@/components/ServiceProviders.vue')
            }, {
                path: '/consultants',
                name: 'Consultant',
                component: () => import('@/components/Consultants.vue')
            }, {
                path: '/operators',
                name: 'Operator',
                component: () => import('@/components/Operators.vue')
            }, {
                path: '/package-items',
                name: 'PackageItemManagement',
                component: () => import('@/components/PackageItem.vue')
            }, {
                path: '/packages',
                name: 'PackageManagement',
                component: () => import('@/components/Package.vue')
            }, {
                path: '/settings',
                name: 'SettingManagement',
                component: () => import('@/components/Setting.vue')
            }, {
                path: '/transaction',
                name: 'TransactionHistory',
                component: () => import('@/components/Transaction.vue')
            }, {
                path: '/profile',
                name: 'UserProfileComponent',
                component: () => import('@/components/Profile.vue')
            }, {
                path: '/operator-package',
                name: 'OperatorPackageBundleView',
                component: () => import('@/components/PackageOp.vue')
            }, {
                path: '/subscribers',
                name: 'SubscriberManagement',
                component: () => import('@/components/Subscriber.vue')
            }, {
                path: '/tickets',
                name: 'SupportTicketManagement',
                component: () => import('@/components/SupportTicket.vue')
            }, {
                path: '/subscription',
                name: 'SubscriptionManagement',
                component: () => import('@/components/Subscription.vue')
            }, {
                path: '/cdn-mapping',
                name: 'CdnMappingManagement',
                component: () => import('@/components/CdnMapping.vue')
            }, {
                path: '/endpoint-transaction',
                name: 'ApiTransactionHistory',
                component: () => import('@/components/ApiTrasaction.vue')
            }, {
                path: '/admin-dashboard',
                name: 'AdminDashboard',
                component: () => import('@/components/AdminDashboard.vue')
            }, {
                path: '/consultant-dashboard',
                name: 'ConsultantDashboard',
                component: () => import('@/components/ConsultantDashboard.vue')
            }, {
                path: '/operator-dashboard',
                name: 'OperatorDashboard',
                component: () => import('@/components/OperatorDashboard.vue')
            }, {
                path: '/recharge',
                name: 'OperatorRecharge',
                component: () => import('@/components/Recharge.vue')
            }, {
                path: '/user-log',
                name: 'AuditLogManagement',
                component: () => import('@/components/Audit.vue')
            }, {
                path: '/subscriber-dashboard',
                name: 'SubscriberDashboard',
                component: () => import('@/components/SubsciberDashboard.vue')
            }, {
                path: '/gateway',
                name: 'Gateway',
                component: () => import('@/components/Gateway.vue')
            }, {
                path: '/notification',
                name: 'Notification',
                component: () => import('@/components/Notification.vue')
            }, {
                path: '/consultant-payout',
                name: 'ConsultantPayout',
                component: () => import('@/components/ConsultantPayout.vue')
            }, {
                path: '/server',
                name: 'Server',
                component: () => import('@/components/Server.vue')
            }
        ]
    }
];

const router = createRouter({
    history: createWebHistory(),
    hash: false,
    routes,
});

export default router;
